import { useTranslation } from 'react-i18next';
import useSWR from 'swr';
import {
  GroupSalesExpand,
  GroupSalesSnapshot,
  GroupSalesTableView,
} from '@/components/Approval/@components/GroupSales';
import { getGroupSalesDraftSourceUrl } from '@/constant/approval';
import { getNestedDataFetcher } from '@/utils/apis';
import {
  hasGroupSalesExpandSnapshot,
  parseGroupSalesAttributes,
  type GroupSalesDraftSource,
} from '@/utils/approval/groupSales';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 61 단체판매 진행 — 저장 content(작성 시점) 그대로, 없거나 펼침 내역 없는 예전 저장분은 지금 내역으로 */
const GroupSalesSlot = ({ data }: ContentExtraProps) => {
  const { t } = useTranslation();
  const saved = parseGroupSalesAttributes(data.attributes);
  const needsLive = !!saved && !hasGroupSalesExpandSnapshot(saved.content);
  const { data: source } = useSWR<GroupSalesDraftSource>(
    saved && needsLive ? getGroupSalesDraftSourceUrl(saved) : null,
    getNestedDataFetcher,
    { revalidateOnFocus: false },
  );
  if (!saved) return null;
  const summary = source?.display.summary;
  return (
    <ContentSlotRoot>
      {saved.content ? (
        <GroupSalesSnapshot content={saved.content} />
      ) : (
        summary && <GroupSalesTableView summary={summary} t={t} />
      )}
      {summary && <GroupSalesExpand summary={summary} t={t} />}
    </ContentSlotRoot>
  );
};

export default GroupSalesSlot;
